import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { IconMapPin } from '@tabler/icons-react';
import { FC } from 'react';

import mobileClasses from '../../styles/farmer-mobile.module.css';
import { geolocationIdleHint } from '../../utils/geolocation-platform';

import classes from './geolocation-prompt.module.css';

interface GeolocationPromptProps {
  geoError: string | null;
  isRequesting: boolean;
  needsPermission: boolean;
  onActivate: () => void;
}

export const GeolocationPrompt: FC<GeolocationPromptProps> = ({
  geoError,
  isRequesting,
  needsPermission,
  onActivate,
}) => {
  if (!needsPermission && !geoError) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Stack gap="sm">
        <Group align="flex-start" gap="sm" wrap="nowrap">
          <Box className={classes.icon}>
            <IconMapPin size={22} stroke={1.75} />
          </Box>
          <Stack gap={4} style={{ flex: 1 }}>
            <Text fw={600} size="sm">
              {geoError
                ? 'Géolocalisation requise'
                : 'Activez votre position'}
            </Text>
            <Text c="dimmed" size="sm">
              {geoError ?? geolocationIdleHint()}
            </Text>
          </Stack>
        </Group>
        <Button
          className={mobileClasses.touchButton}
          fullWidth
          leftSection={<IconMapPin size={20} />}
          loading={isRequesting}
          onClick={onActivate}
          size="lg"
          type="button"
        >
          {geoError ? 'Réessayer' : 'Activer ma position'}
        </Button>
      </Stack>
    </Box>
  );
};
